import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Back from "../components/button/back";

const Perpustakaan = () => {
  const [buku, setBuku] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFullDesc, setShowFullDesc] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleCount, setVisibleCount] = useState(8); // jumlah buku awal yang tampil
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBuku = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL_PERPUSTAKAAN}api/buku`
        );
        setBuku(res.data);
      } catch (error) {
        console.error("Gagal mengambil data perpustakaan:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBuku();
  }, []);

  const handleClick = (id) => {
    navigate(`/perpustakaan/${id}`);
  };

  const toggleDeskripsi = (id) => {
    setShowFullDesc((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const filteredBuku = buku.filter((item) =>
    item.judul?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Ambil buku yang akan ditampilkan sesuai visibleCount
  const visibleBuku = filteredBuku.slice(0, visibleCount);

  const loadMore = () => {
    setVisibleCount((prev) => prev + 8); // menambahkan 8 buku lagi
  };

  return (
    <div className="min-h-screen px-4 sm:px-6 lg:px-10 py-6 bg-gray-50 dark:bg-gray-900 transition-colors">
      <div className="mb-4">
        <Link to="/">
          <Back />
        </Link>
      </div>

      <h1 className="text-center text-2xl sm:text-3xl font-bold text-gray-800 dark:text-white mb-6">
        📚 Perpustakaan Digital
      </h1>

      <div className="max-w-lg mx-auto mb-8">
        <input
          type="text"
          placeholder="Cari judul buku..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-700 
                     bg-white dark:bg-gray-800 text-gray-800 dark:text-white
                     focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {loading ? (
        <p className="text-center text-gray-500 dark:text-gray-400">
          Memuat data buku...
        </p>
      ) : visibleBuku.length === 0 ? (
        <p className="text-center text-gray-500 dark:text-gray-400">
          Buku tidak ditemukan.
        </p>
      ) : (
        <>
          <div
            className="
              grid gap-6
              grid-cols-2
              sm:grid-cols-3
              md:grid-cols-4
              lg:grid-cols-5
            "
          >
            {visibleBuku.map((item) => {
              const fullDeskripsi = showFullDesc[item._id];
              const words = item.deskripsi?.split(" ") || [];
              const shortDesc = words.slice(0, 12).join(" ");
              const hasMore = words.length > 12;

              return (
                <div
                  key={item._id}
                  onClick={() => handleClick(item._id)}
                  className="
                    group cursor-pointer rounded-2xl overflow-hidden
                    bg-white dark:bg-gray-800
                    shadow-md hover:shadow-xl
                    transition-all duration-300
                  "
                >
                  <div className="relative w-full aspect-[3/4] bg-gray-200 dark:bg-gray-700 overflow-hidden">
                    {item.coverImageFilename ? (
                      <img
                        src={`${process.env.REACT_APP_API_URL_PERPUSTAKAAN}api/buku/file/${item.coverImageFilename}`}
                        alt={item.judul}
                        className="
                          w-full h-full object-cover
                          group-hover:scale-105 transition-transform duration-300
                        "
                      />
                    ) : (
                      <div className="flex items-center justify-center h-full text-gray-400 text-sm">
                        Tidak ada cover
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <h2 className="font-semibold text-sm sm:text-base text-gray-800 dark:text-white line-clamp-2 mb-2">
                      {item.judul}
                    </h2>

                    {item.deskripsi && (
                      <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-300">
                        <p>
                          {fullDeskripsi ? item.deskripsi : shortDesc}
                          {hasMore && !fullDeskripsi && "..."}
                        </p>

                        {hasMore && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleDeskripsi(item._id);
                            }}
                            className="
                              mt-1 text-blue-500 hover:text-blue-600
                              text-xs underline
                            "
                          >
                            {fullDeskripsi
                              ? "Sembunyikan"
                              : "Baca selengkapnya"}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Tombol Muat Lebih Banyak */}
          {visibleCount < filteredBuku.length && (
            <div className="flex justify-center mt-6">
              <button
                onClick={loadMore}
                className="px-6 py-2 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition-colors"
              >
                Muat Lebih Banyak
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Perpustakaan;
